<template>
    <div class="container-fluid w-100 pb-3" style="overflow: hidden">
        <navbar :title="$t('menu.admin_companies')"/>
        <div class="col-sm-12 nopads">
           <Transition name="fade">
            <company-list
              :results="results"
              @add="addCompany"
              @edit="editCompany"
            />
          </Transition>
            <base-modal v-if="editMode" hide-footer hide-header size="lg" @close="showList" :prevent-close="true">
                <company-editor
                    v-if="editMode"
                    :company="company"
                    @close="showList"
                    @close-and-update="closeAndUpdate"
                />
            </base-modal>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
  </div>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import CompanyList from './CompanyList'
import CompanyEditor from './CompanyEditor'
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'Companies',
    components: {BaseModal, Navbar, CompanyList, CompanyEditor},
    mixins: [restApi, workManagementHelper],
    data: function () {
        return {
            results: [],
            company: null,
            editMode: false,
            loading: true
        }
    },
    mounted: function () {
        this.fetchCompanies()
    },
    methods: {

        fetchCompanies: function () {
            this.loading = true
            this.restFetch(this.companyUrl, this.handleResponse)
        },

        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },

        editCompany: function (company) {
            this.company = company
            if (!this.company.location) {
                this.company.location = {x: null, y: null}
            }
            this.editMode = true
        },

        addCompany: function () {
            this.company = this.newCompany()
            this.editMode = true
        },

        showList: function () {
            this.editMode = false
        },

        closeAndUpdate: function () {
            this.fetchCompanies()
            this.showList()
        }

    }
}
</script>
